// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_17GKh65qQ1uUpcA4mt9lF2","music-repo":"_2z8VWXdvBu3Q7LrZTH_nU1","ctx":"_36DyThAUmoCJBzlWLt3YY_","progress":"in9ofmCDlypMAq9xTr8vI","time":"_3P6DFsKXMsF2f5hWLwXewV","volume":"_3wRotHFVQSxKBS-Nf0OQ4e","desc":"_1rNwJyonOlXTtrvk1z9fQu","music-name":"_3qIWZN9VrVNax61mCnp_0W","music-author":"_2c1oXXNdD9QgG4u5UtjD2c","control":"_6WzS3FiHeI2OwCB3OESO9","control-left":"_3DIP3DNavDvksKvWwKbGbD","control-right":"_1Rlm4QTDGmL5zSMTGZdFn2","circle-0":"_2xP-VTD3hgSVTnSUx1qBHH","circle-1":"_2Lwsh26Re6eudGumj4qpIa","circle-2":"_3URh4vPmOjIb7i3sfRjF-Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/style/Player.less
// module id = 223
// module chunks = 0